import { Box, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import GenericAutoComplete from "components/Autocomplete";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { companyStatusOptions } from "utils/stepsOptions";

export default function CompanyForm() {
  const { t } = useTranslation();
  const { control } = useFormContext();

  return (
    <Box display="flex" gap={2}>
      <Controller
        name="company"
        control={control}
        render={({ field, fieldState: { error } }) => {
          return (
            <FormControl fullWidth error={!!error}>
              <GenericAutoComplete
                {...field}
                placeholder={t("Company name")}
                filter="nameContains"
                onChange={(_, newValue) => {
                  field.onChange(newValue);
                }}
              />
            </FormControl>
          );
        }}
      />
      <Controller
        name="companyStatus"
        control={control}
        rules={{ required: true }}
        render={({ field, fieldState: { error } }) => {
          return (
            <FormControl fullWidth error={!!error}>
              <InputLabel>{`${t("Company status")} *`}</InputLabel>
              <Select {...field} label={`${t("Company status")} *`}>
                {companyStatusOptions.map(option => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          );
        }}
      />
    </Box>
  );
}
